module.exports = __webpack_public_path__ + "img/icon-circles-active.bf4e8dc7.svg";